module.exports = {"svg":{"$":{"t":"1622103060810","class":"icon","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"2316","width":"16","height":"16","xmlns:xlink":"http://www.w3.org/1999/xlink"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M688 460.8H329.6l179.2 179.2z","fill":"#00000","p-id":"2317"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/k-menu/down-black.svg
// module id = bwJX
// module chunks = 1